/**
 * Themed loading state — mirrors the final layout (badge + name + card)
 * with a shimmer sweep, so there's no layout jump when data arrives and
 * never a blank/white flash. Respects prefers-reduced-motion globally
 * (see src/index.css), which freezes the shimmer to a static skeleton.
 */
export default function CeremonyLoading() {
  return (
    <div className="ceremony-loading" role="status" aria-live="polite">
      <span className="sr-only">جارٍ تحميل الدعوة…</span>
      <div className="ceremony-loading__badge" />
      <div className="ceremony-loading__line ceremony-loading__line--name" />
      <div className="ceremony-loading__line ceremony-loading__line--subtitle" />
      <div className="ceremony-loading__card" />
    </div>
  );
}
